<template>
	<div>
		<ExpensesTabs
			v-if="claimId === 0"
			:tab="'Manager Review'"
			@tab="onTabChange($event)"			
		/>
		<ClaimDetailTitle 
			class="head-title px-6 d-print-none"
			:title="claim_local && `${claim_local.number} - ${claim_local.description}`" 
			:text="'Back to Claims for Approval'" 
			:isClose="claimId !== 0 ? true : false"
			@back="onBack()"
		/>
		<ProgressGetDataLinear v-if="loading" class="px-5"/>
		<div v-if="!loading" class="approval-content ma-5" >
			<ApprovalButton 
				class="px-5 py-3 d-print-none"
				:isApproval="claim_local.approval_by.id === user_abid && claim_local.status === claim_status.pending.value"
				:isMoreInfo="claim_local.status === claim_status.pending.value"
				:isForward="claim_local.approval_by.id === user_abid && claim_local.status === claim_status.pending.value"
				:isDelete="(isFinanceUser ? true : claim_local.supplier.id === user_abid) && isAbleDelete"
				:approveLoading="approve_loading"
				:rejectLoading="visible_moreinfo"
				:forwardLoading="visible_forward"
				:deleteLoading="visible_delete"
				:printLoading="visible_print"
				:claimId="claimId"
				@approve="onApprove()"
				@more-info="onMoreInfoDialog()"
				@forward="onForwardDialog()"
				@delete="onDeleteDialog()"
				@print="onPrint()"/>
			<v-row class="mx-0 my-3 px-3" style="width: 100%">
				<v-col :cols="$vuetify.breakpoint.xs ? 12 : 2" class="claim-summary-field py-0">
					<div class="content-info-title">Submitted date</div>
					<v-text-field
						:value="claim_local.submitted_date"
						outlined
						disabled
						dense
						hide-details
					>
						<template v-slot:prepend-inner>
							<Calendar class="mr-1" style="margin-top: 2px" color="rgba(0, 0, 0, 0.38)" width="20" height="20"/>
						</template>
					</v-text-field>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xs ? 12 : 2" class="claim-summary-field py-0">
					<div class="content-info-title">Claim date</div>
					<v-text-field
						:value="claim_local.date"
						outlined
						disabled
						dense
						hide-details
					>
						<template v-slot:prepend-inner>
							<Calendar class="mr-1" style="margin-top: 2px" color="rgba(0, 0, 0, 0.38)" width="20" height="20"/>
						</template>
					</v-text-field>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xs ? 12 : 2" class="claim-summary-field py-0">
					<div class="content-info-title">Period</div>
					<v-text-field
						:value="claim_local.period.period_desc"
						outlined
						disabled
						dense
						hide-details
					/>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xs ? 12 : 2" class="claim-summary-field py-0">
					<div class="content-info-title">Currency</div>
					<v-text-field
						:value="claim_local.currency.code"
						outlined
						disabled
						dense
						hide-details
					/>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xs ? 12 : 2" class="claim-summary-field py-0">
					<div class="content-info-title">Amount</div>
					<v-text-field
						:value="`${claim_local.currency.symbol} ${formatNumber(gross)}`"
						outlined
						disabled
						dense
						hide-details
					/>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xs ? 12 : 2" class="claim-summary-field py-0">
					<div class="content-info-title">GST</div>
					<v-text-field
						:value="`${claim_local.currency.symbol} ${formatNumber(tax)}`"
						outlined
						disabled
						dense
						hide-details
					/>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xs ? 12 : 2" class="claim-summary-field py-0">
					<div class="content-info-title">To Pay</div>
					<v-text-field
						:value="`${claim_local.currency.symbol} ${formatNumber(amount)}`"
						outlined
						disabled
						dense
						hide-details
					/>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xs ? 12 : 2" class="claim-summary-field py-0">
					<div class="content-info-title">Claim description</div>
					<v-text-field
						:value="claim_local.description"
						outlined
						disabled
						dense
						hide-details
					/>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xs ? 12 : 2" class="claim-summary-field py-0">
					<div class="content-info-title">Employee</div>
					<v-text-field
						:value="claim_local.supplier.display_name"
						outlined
						disabled
						dense
						hide-details
					/>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xs ? 12 : 2" class="claim-summary-field py-0">
					<div class="content-info-title">Approval by</div>
					<v-text-field
						:value="claim_local.approval_by.display_name"
						outlined
						disabled
						dense
						hide-details
					/>
				</v-col>
				<v-col v-if="claim_local.remark && claim_local.remark.length !== 0" :cols="$vuetify.breakpoint.xs ? 12 : 2" class="claim-summary-field py-0">
					<div class="content-info-title">Comments</div>
					<v-text-field
						:value="formatRemark(claim_local.remark)"
						outlined
						disabled
						dense
						hide-details
					/>
				</v-col>
			</v-row>
			<div class="content-attached-title px-5">Attached Expenses</div>
			<TableAttachedReceipt 
				class="content-table mt-2 mb-5"
				:header="head_local"
				:items="filterResults"
				:color="color" 
				:currencies="currencies"
				:symbol="claim_local.currency.symbol"
				:gross="formatNumber(gross)"
				:tax="formatNumber(tax)"
				:amount="formatNumber(amount)"
				:markup="formatNumber(markupSum)"
				:isFile="true"
				:isFileView="true"
				@show-file="onShowFile($event)"
			/>
			<ReceiptImageView 
				v-if="image_visible"
				:visible="image_visible" 
				:show_image="show_image"
				@image-close="image_visible = false"
			/>
			<ApprovalDialog 
				v-if="visible_moreinfo"
				key="moreinfo"
				:visible="visible_moreinfo" 
				:color="color"
				:title_text="`Describe the information required for this claim...`"
				:suppliers="[claim_local.supplier]"
				@cancel="onCancel()"
				@ok="onMoreInfo($event)"
			/>
			<ApprovalDialog 
				v-if="visible_forward"
				key="forward"
				:visible="visible_forward" 
				:color="color"
				:title_text="`Forward claim`"
				:isForward="true"
				:userID="user_abid"
				:confirm_button="`Submit`"
				@cancel="onCancel()"
				@submit="onForward($event)"
			/>
			<DeleteConfirmDialog
				v-if="visible_delete"
				:visible="visible_delete"
				:title="`You are about to delete claim`"
				:content="`This action cannot be undone. Are you sure?`"
				:okText="`Delete`"
				@cancel="onCancel()"
				@ok="onDelete()"
			/>
			<DialogProgress 
				:visible="visible_progress" 
				:color="color"
			/>
			<PrintClaims
				v-if="visible_print"  
				id="print"
				style="display: none"
				:printClaims="print_claims" />
		</div>
	</div>
</template>
<script>
import ClaimDetailTitle from "@/views/expenses/commond/claim_detail_title.vue";
import TableAttachedReceipt from "@/components/table/table_attached_receipt.vue";
import ApprovalButton from "@/views/expenses/approvals/approval_button.vue";
import ReceiptImageView from "@/views/expenses/receipts/receipt_image_view.vue";
import PrintClaims from '@/components/expenses/print_claims';
import DialogProgress from "@/components/dialogs/progress_dialog.vue";
import ExpensesTabs from "@/views/expenses/commond/expenses_tabs";
import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";
import ApprovalDialog from "@/views/expenses/approvals/approval_dialog.vue";
import DeleteConfirmDialog from "@/views/expenses/commond/delete_confirm_dialog.vue";
import Calendar from "@/components/icons/calendar.vue";

import config from "@/config.js";
import moment from 'moment';
import { metaReceiptMixin } from "@/mixins/expenses/metaReceiptMixin";

import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
import pdfjsworker from 'pdfjs-dist/es5/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsworker;

const SCALE = 1.2;
const MAX_WIDTH = 600;
const PAGE_INIT = 0;

const CLAIM_STATUSES = config.claim_statuses;
const HEAD = config.finance_receipt_head;

// Edit expense claim privilege
const EECP = 'Secapa';

export default {
	name: 'ApprovalClaimContent',
	mixins: [metaReceiptMixin],
	components: {
		TableAttachedReceipt,
		ApprovalButton,
		ReceiptImageView,
		PrintClaims,
		DialogProgress,
		ClaimDetailTitle,
		ExpensesTabs,
		ProgressGetDataLinear,
		ApprovalDialog,
		DeleteConfirmDialog,
		Calendar
	},
	props: {
		claimId: {
			type: Number,
			default: 0
		}
	},
	data() {
		this.claim_status = CLAIM_STATUSES;
		this.head_local = HEAD.filter(h => { return h.value !== 'select' });
		return {
			color: this.$attrs.color ? this.$attrs.color : '#FFB946',
			currencies: [],
			loading: false,
			claim_local: null,

			visible_moreinfo: false,
			visible_forward: false,
			visible_delete: false,
			image_visible: false,

			print_claims: [],
			image_arr: [],
			visible_progress: false,
			visible_print: false,
			approve_loading: false
		}
	},
	created() {
		this.update_breadcrumb();
		
		const id = this.claimId !== 0 ? this.claimId : this.$route.params.id;
		this.loadClaim(id);
	},
	computed: {
		amount() {
			// amount come from API, for approval stage, needn't exchange
			let amount = '0.00';

			if (this.claim_local.details && this.claim_local.details.length === 1) {
				const value = this.claim_local.details[0].amount;
				amount = typeof(value) === 'string' ? value :value.toFixed(2).toString();
			}

			if (this.claim_local.details && this.claim_local.details.length > 1) {
				const amount_arr_tmp = this.claim_local.details.map(detail => {return typeof(detail) === 'string' ? detail.amount : detail.amount.toString()});
				const value = amount_arr_tmp.reduce((accumulator, currentValue) => {return this._add(accumulator, currentValue)});
				
				amount = Number(value).toFixed(2).toString();
			}
			
			return amount;
		},
		gross() {
			// amount come from API, for approval stage, needn't exchange
			let gross = '0.00';

			if (this.claim_local.details && this.claim_local.details.length === 1) {
				const value = this.claim_local.details[0].gross;
				gross = typeof(value) === 'string'? Number(value).toFixed(2) : value.toFixed(2);
			}

			if (this.claim_local.details && this.claim_local.details.length > 1) {
				const amount_arr_tmp = this.claim_local.details.map(detail => {return typeof(detail.gross) === 'string' ? detail.gross : detail.gross.toString()});
				const value = amount_arr_tmp.reduce((accumulator, currentValue) => {return this._add(accumulator, currentValue)});
				
				gross = Number(value).toFixed(2);
			}
			
			return gross;
		},
		tax() {
			// amount come from API, for approval stage, needn't exchange
			let tax = '0.00';

			if (this.claim_local.details && this.claim_local.details.length === 1) {
				const value = this.claim_local.details[0].tax_amount;
				tax = typeof(value) === 'string'? Number(value).toFixed(2) : value.toFixed(2);
			}

			if (this.claim_local.details && this.claim_local.details.length > 1) {
				const amount_arr_tmp = this.claim_local.details.map(detail => {return typeof(detail.tax_amount) === 'string' ? detail.tax_amount : detail.tax_amount.toString()});
				const value = amount_arr_tmp.reduce((accumulator, currentValue) => {return this._add(accumulator, currentValue)});
				
				tax = Number(value).toFixed(2);
			}
			
			return tax;
		},
		markupSum() {
			// amount come from API, for approval stage, needn't exchange
			let markup = '0.00';

			if (this.claim_local.details && this.claim_local.details.length === 1) {
				const value = this.claim_local.details[0].value_fc;
				markup = typeof(value) === 'string'? Number(value).toFixed(2) : value.toFixed(2);
			}

			if (this.claim_local.details && this.claim_local.details.length > 1) {
				const amount_arr_tmp = this.claim_local.details.map(detail => {return typeof(detail.value_fc) === 'string' ? detail.value_fc : detail.value_fc.toString()});
				const value = amount_arr_tmp.reduce((accumulator, currentValue) => {return this._add(accumulator, currentValue)});
				
				markup = Number(value).toFixed(2);
			}
			
			return markup;
		},
		filterResults() {
			const filterRes = [];
			this.claim_local.details.forEach(detail => {
				const obj = {};		
				obj['id']	= detail.id;
				obj['date']	= detail.receipt.date;
				obj['currency']	= this.claim_local.currency;
				obj['amount'] = Number(detail.amount);
				obj['gross'] = Number(detail.gross);
				obj['tax_amount'] = Number(detail.tax_amount);
				obj['tax_mode_desc'] = detail.tax_mode_desc;
				obj['markup_perc'] = Number(Number(detail.markup).toFixed(2));
				obj['value'] = Number(detail.value_fc);
				obj['kind'] = detail.kind;
				obj['code'] = detail.job;
				obj['title'] = detail.job;
				obj['phase'] = detail.phase;
				obj['description'] = detail.description;
				obj['thumbnail'] = detail.receipt.thumbnail;
				obj['image'] = detail.receipt.image;
				obj['image_type'] = detail.receipt.image_type;
				obj['receipt_id'] = detail.receipt.id;

				filterRes.push(obj);
			});
			return filterRes;
		},
		user_abid() {
			const user = this.$store.state.user;
			if (user && user.addressbook) {
				return user.addressbook.id
			} else {
				return 0;
			}
		},
		user_abid_name() {
			let name = '';
			const user = this.$store.state.user;
			if (user) {
				name = user.addressbook.display_name;
			}
			return name;
		},
		isFinanceUser() {
			let isFinanceUserTmp = false;
			const privileges = this.$store.state.privileges;
			if (privileges.length !== 0 && privileges.includes(EECP)) {
				isFinanceUserTmp = true;
			}
			return isFinanceUserTmp;
		},
		isAbleDelete() {
			let is_able_delete = true;
			if (this.claim_local.status === this.claim_status.deleted.value || this.claim_local.status === this.claim_status.paid.value || this.claim_local.status === this.claim_status.partiallyPaid.value || this.claim_local.status === this.claim_status.posted.value) {
				is_able_delete = false;
			}
			return is_able_delete
		}
	},
	methods: {
		loadClaim(id) {
			this.loading = true;
			const url = "/api/expenses/claims/" + id;
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " +this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.claim_local = data;						
						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		onTabChange(current_tab) {
			this.$router.push({ name: current_tab });
		},
		onBack() {
			if (this.claimId !== 0) {
				this.$emit('close');
			} else {
				this.$router.push({ name: 'Manager Review' });
			}
		},
		formatNumber(num) {
			let res = 0;
			if (Number.isInteger(num)) {
				const integer = num.toLocaleString();
				res = integer + '.00';
			} else {
				const num_arr = (num.toString()).split('.');
				const integer = Number(num_arr[0]).toLocaleString();

				if (num_arr.length > 1) {
					if (num_arr[1].length === 1) {
						res = integer + '.' + num_arr[1] + '0';
					} else {
						res = integer + '.' + num_arr[1];
					}
					
				} else {
					res = integer + '.00' ;
				}
			}
			return res;
		},
		formatRemark(remark) {
			let remark_tmp = '';

			const remark_arr = remark.split(config.remark_date_flag);
			remark_tmp = remark_arr[0];

			return remark_tmp
		},
		onShowFile(show_image) {
			this.show_image = show_image;
			this.image_visible = true;
		},
		onApprove() {
			if (this.approve_loading) return;

			if (this.claim_local.status === CLAIM_STATUSES.pending.value) {
				this.approve_loading = true;

				const details = [];
				this.claim_local.details.forEach(detail => {
					details.push({
						receipt_id: detail.receipt.id,
						amount: Number(Number(detail.amount).toFixed(2)),
						description: detail.description,
						phase_id: detail.phase.id,
						job_id: detail.job.id,
						kind_id: detail.kind.id,
						gross: Number(Number(detail.gross).toFixed(2)),
						tax_mode: detail.tax_mode,
						tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
						tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
						markup: Number(Number(detail.markup).toFixed(2)),
						value_fc: Number(Number(detail.value_fc).toFixed(2)),
					})
				});

				const update_obj = {
					supplier_id: this.claim_local.supplier.id,
					date: this.claim_local.date,
					desc: this.claim_local.description,
					currency_id: this.claim_local.currency.id,
					approval_by: this.claim_local.approval_by.id,
					status: CLAIM_STATUSES.approved.value,
					remark: '',
					period_id: this.claim_local.period.id,
					details: details
				};
				this._update_claim(this.claim_local.id, update_obj);
			}
		},
		onMoreInfoDialog() {
			if (this.visible_moreinfo) return;

			if (this.claim_local.status === CLAIM_STATUSES.pending.value) {
				this.visible_moreinfo = true;
			}
		},
		onMoreInfo(reason) {
			const reason_with_date = `${reason}${config.remark_date_flag}${moment().format('YYYY-MM-DD')}`;

			const details = [];
			this.claim_local.details.forEach(detail => {
				details.push({
					receipt_id: detail.receipt.id,
					amount: Number(Number(detail.amount).toFixed(2)),
					description: detail.description,
					phase_id: detail.phase.id,
					job_id: detail.job.id,
					kind_id: detail.kind.id,
					gross: Number(Number(detail.gross).toFixed(2)),
					tax_mode: detail.tax_mode,
					tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
					tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
					markup: Number(Number(detail.markup).toFixed(2)),
					value_fc: Number(Number(detail.value_fc).toFixed(2)),
				});
			});

			const update_obj = {
				supplier_id: this.claim_local.supplier.id,
				date: this.claim_local.date,
				desc: this.claim_local.description,
				currency_id: this.claim_local.currency.id,
				approval_by: this.claim_local.approval_by.id,
				status: CLAIM_STATUSES.rejected.value,
				remark: reason_with_date,
				period_id: this.claim_local.period.id,
				details: details
			};
			this._update_claim(this.claim_local.id, update_obj);
		},
		onForwardDialog() {
			if (this.visible_forward) return;

			if (this.claim_local.status === this.claim_status.pending.value) {
				this.visible_forward = true;
			}
		},
		onForward(event) {
			const details = [];
			this.claim_local.details.forEach(detail => {
				details.push({
					receipt_id: detail.receipt.id,
					amount: Number(Number(detail.amount).toFixed(2)),
					description: detail.description,
					phase_id: detail.phase.id,
					job_id: detail.job.id,
					kind_id: detail.kind.id,
					gross: Number(Number(detail.gross).toFixed(2)),
					tax_mode: detail.tax_mode,
					tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
					tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
					markup: Number(Number(detail.markup).toFixed(2)),
					value_fc: Number(Number(detail.value_fc).toFixed(2)),
				})
			});

			const update_obj = {
				supplier_id: this.claim_local.supplier.id,
				date: this.claim_local.date,
				desc: this.claim_local.description,
				currency_id: this.claim_local.currency.id,
				approval_by: event.approval_by.id,
				status: this.claim_local.status,
				remark: event.reason,
				period_id: this.claim_local.period.id,
				send_email: true,
				details: details
			};
			this._update_claim(this.claim_local.id, update_obj);
		},
		onDeleteDialog() {
			if (this.visible_delete) return;

			if (this.isFinanceUser) {
				this.visible_delete = true;
			} else {
				if (this.claim_local.supplier.id === this.user_abid) {
					this.visible_delete = true;
				}
			}
		},
		onDelete() {
			this._delete_claim(this.claim_local.id);
		},
		onCancel() {
			this.visible_forward = false;
			this.visible_moreinfo = false;
			this.visible_delete = false;
		},
		async onPrint() {
			if (this.visible_print) return;

			this.visible_progress = true;
			this.visible_print = true;
			this.print_claims = [];
			const receipt_with_image  = this.claim_local.details.filter(d => { return d.receipt.image_type.length !== 0 });

			const image_blob_arr = [];
			for (let index = 0; index < receipt_with_image.length; index++) {
				const detail = receipt_with_image[index];
				const url = `/api/expenses/receipts/${detail.receipt.id}/image`;
				await axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						},
						responseType: 'blob',
					})
					.then((val) => {
						const { status, data } = val;
						if (status === 200) {
							const data_obj = {
								id: this.claim.id,
								data: data
							};
							image_blob_arr.push(data_obj);
						}
					})
					.catch((e) => {
						this.$emit('error-msg', e.message);
					});
			}

			if (image_blob_arr.length === 0) {
				this.setPrintItem();
			} else {
				this.getImageList(image_blob_arr);
			}
		},
		getImageList(image_blob_arr) {
			for (let index = 0; index < image_blob_arr.length; index++) {
				const image_blob = image_blob_arr[index];
				if (image_blob.data.type === 'application/pdf') {
					const reader = new FileReader();
					reader.readAsDataURL(image_blob.data);
					reader.onload = readerEvent =>  {
						const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
						loadingTask.promise.then(pdf => {
							const preview_url = [];
							let page_total = pdf.numPages;

							for (let index = 0; index < pdf.numPages; index++) {
								pdf.getPage(index + 1).then(page => {
									const scale = SCALE;
									const viewport = page.getViewport({scale: scale});

									const canvas = document.createElement('canvas');
									const context = canvas.getContext('2d');
									canvas.width = viewport.width;
									canvas.height = viewport.height;

									const renderContext = {
										canvasContext: context,
										viewport: viewport
									};

									const renderTask = page.render(renderContext);
									renderTask.promise.then(() => {
										canvas.toBlob(blob => {
											const preview_item_url = URL.createObjectURL(blob);
											preview_url.push(preview_item_url);
											page_total -= 1;

											if (page_total === PAGE_INIT) {
												const dimension = this.getDimension(viewport.width, viewport.height);
												const image_obj = {
													id: image_blob.id,
													width: dimension.width,
													height: dimension.height,
													image: preview_url
												};
												this.image_arr.push(image_obj);

												if (this.image_arr.length === image_blob_arr.length) {
													this.setPrintItem();
												}
											}
										});									
									});
								});
							}
						});
					};
				} else {
					const my_image = new Image();
					const preview_item_url = URL.createObjectURL(image_blob.data);
					my_image.src = preview_item_url;
					my_image.onload = () => {
						const dimension = this.getDimension(my_image.width, my_image.height);
						const image_obj = {
							id: image_blob.id,
							width: dimension.width,
							height: dimension.height,
							image: preview_item_url
						};
						this.image_arr.push(image_obj);

						if (this.image_arr.length === image_blob_arr.length) {
							this.setPrintItem();
						}
					}
				}				
			}
		},
		getDimension(width, height) {
			let image_width = 0;
			let image_height = 0;

			if (this.$vuetify.breakpoint.smAndDown) {
				/* 48 = padding-left-24px + padding-right-24px */
				if (width > height) {
					image_width = this.$vuetify.breakpoint.width - 48;
					image_height = (this.$vuetify.breakpoint.width - 48) * height / width;
				} else {
					image_height = this.$vuetify.breakpoint.width - 48;
					image_width = (this.$vuetify.breakpoint.width - 48) * width / height;
				}
			} else {
				if (width > height) {
					image_width = MAX_WIDTH;
					image_height = MAX_WIDTH * height / width;
				} else {
					image_height = MAX_WIDTH;
					image_width = MAX_WIDTH * width / height;
				}
			}

			return { width: image_width, height: image_height };
		},
		setPrintItem() {
			const obj = {
				id: this.claim_local.id,
				number: this.claim_local.number,
				desc: this.claim_local.description,
				submitted_date: this.submitted_date,
				value: this.amount,
				currency: this.claim_local.currency.symbol,
				approval_by: this.claim_local.approval_by.display_name,
				employee: this.claim_local.supplier.display_name,
				supplier: this.claim_local.supplier.display_name,
				claim_date: this.claim_local.date,
				details: this.claim_local.details,
				image_arr: this.image_arr
			}
			this.print_claims.push(obj);
			this.visible_progress = false;

			setTimeout(() => { 
				const printHtml = document.getElementById("print").innerHTML;
				const printFrame = document.createElement('iframe');
				printFrame.srcdoc = printHtml;
				document.body.appendChild(printFrame);

				printFrame.onload = () => {
					printFrame.contentWindow.print();
					
					const mql = printFrame.contentWindow.matchMedia('print');
					mql.onchange = (e) => {
						if (e.matches) {
							/* before print */
						} else {
							/* after print */
							document.body.removeChild(printFrame);
							this.visible_print = false;
							this.print_claims = [];
							this.image_arr = [];
						}
					}
				}
			},20);
		},
		update_breadcrumb() {
			// add this page to our breadcrumbs
			this.$store.commit("push_breadcrumb", {
				exact: true,
				text: `Approved Claim ${this.$route.params.id}`,
				to: `/expenses/manager_review/${this.$route.params.id}`
			});
		},
		_update_claim(id, update_obj) {
			const url = "/api/expenses/claims/" + id;
			axios
				.put(url, update_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.onBack();
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.approve_loading = false;
					this.visible_moreinfo = false;
					this.visible_forward = false;
				});
		},
		async _delete_claim(id) {
			const url = `/api/expenses/claims/${id}`;
			await axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.onBack();
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.visible_delete = false;
				});
		},
		_add(num1, num2) {
			const num1Digits = (num1.split('.')[1] || '').length;
			const num2Digits = (num2.split('.')[1] || '').length;
			const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
			const result = (num1 * baseNum + num2 * baseNum) / baseNum;
			return result.toString();
		},
	}
}
</script>
<style lang="scss" scoped>
.approval-content {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  background: #FAFAFA;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
}
.head-title {
  height: 68px;
  background: #FFFFFF;
}
.content-info {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  width: 100%;
}
.content-info-xs {
  display: flex;
  flex-flow: column nowrap;
	align-items: flex-start;
  width: 100%;
}
.claim-summary-field {
	min-width: 240px;
}
.content-info-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
}
.content-info-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
}
.content-info-default-color {
  color: #37495F
}
.content-info-special-color {
  color: #EE0202;
}
.content-attached-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #192A3E;
}
.content-table {
  width: 100%;
}
::v-deep {
	.text-red-text.v-input--is-disabled input {
		color: #EE0202;
	}
	.text-red-text.v-text-field--outlined fieldset {
		border-color: red;
	}
}


</style>
